import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-page">
      <div className="hero">
        <h1>Welcome to Report Generator</h1>
        <p>Create notes, documents, and organize your thoughts in one place.</p>
        {/* <div className="hero-actions">
          <button
            onClick={() => navigate('/page/new/edit')}
            className="primary-btn"
          >
            Create New Page
          </button>
        </div> */}
      </div>

      <div className="features">
        <div className="feature">
          <div className="feature-icon">📝</div>
          <h3>Rich Text Editor</h3>
          <p>Format text with headers, lists, code blocks, and more.</p>
        </div>
        <div className="feature">
          <div className="feature-icon">🖼️</div>
          <h3>Media Support</h3>
          <p>Upload images and files directly into your pages.</p>
        </div>
        <div className="feature">
          <div className="feature-icon">🔗</div>
          <h3>Link Anything</h3>
          <p>Create links between pages and external resources.</p>
        </div>
        {/* <div className="feature">
          <div className="feature-icon">💾</div>
          <h3>Auto Save</h3>
          <p>Your work is automatically saved as you type.</p>
        </div> */}
      </div>
    </div>
  );
};

export default Home;